/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Action } from '@ngrx/store';
import { TenantDetails } from 'app/page-modules/tenant-management/models';

// -------------------------------------------------------------------------
// Select tenant details
export const SELECT_TENANT_DETAILS = '[Tenant Management] Select Tenant Details';

// -------------------------------------------------------------------------
export const SHOW_TENANT_CREATION_WIZARD = '[Tenant Management] Show Tenant Creation Wizard';
export const HIDE_TENANT_CREATION_WIZARD = '[Tenant Management] Hide Tenant Creation Wizard';

// -------------------------------------------------------------------------
export const SHOW_USER_CREATION_WIZARD = '[Tenant Management] Show User Creation Wizard';
export const HIDE_USER_CREATION_WIZARD = '[Tenant Management] Hide User Creation Wizard';

// -------------------------------------------------------------------------
export class SelectTenantDetails implements Action {
  readonly type = SELECT_TENANT_DETAILS;

  constructor(public tenantDetails: TenantDetails) {}
}

// -------------------------------------------------------------------------
export class ShowTenantCreationWizard implements Action {
  readonly type = SHOW_TENANT_CREATION_WIZARD;
}

export class HideTenantCreationWizard implements Action {
  readonly type = HIDE_TENANT_CREATION_WIZARD;
}

// -------------------------------------------------------------------------
export class ShowUserCreationWizard implements Action {
  readonly type = SHOW_USER_CREATION_WIZARD;
}

export class HideUserCreationWizard implements Action {
  readonly type = HIDE_USER_CREATION_WIZARD;
}

// -------------------------------------------------------------------------
export type All =
  | SelectTenantDetails
  | ShowTenantCreationWizard
  | HideTenantCreationWizard
  | ShowUserCreationWizard
  | HideUserCreationWizard;
